<template>
  <div class="">
    <div class="btns">
      <div class="tools-box right">
        <Button @click="$emit('exportForm')" type="primary" ghost>导出</Button>
      </div>
    </div>
    <div class="statistics-container">
      <div class="statistics-item">
        <span class="dot"></span>
        <span>保单数：</span>
        <span class="num">{{ summaryData.counts || 0 }}</span>
      </div>

      <div class="statistics-item">
        <span class="dot"></span>
        <span>保费：</span>
        <span class="num">{{ summaryData.totalFee || 0 }}元</span>
      </div>

      <div class="statistics-item">
        <span class="dot"></span>
        <span>上游已结算费用：</span>
        <span class="num">{{ summaryData.settledCommissionPrice || 0 }}元</span>
        <div>
          （
          <span>已完成对账费用：</span>
          <span class="num" style="padding-right:10px">{{ summaryData.settledReconciledCommissionPrice || 0 }}元</span>
          <span>未完成对账费用：</span>
          <span class="num">{{ summaryData.settledUnreconciliationCommissionPrice || 0 }}元</span>
          ）
        </div>
      </div>

      <div class="statistics-item">
        <span class="dot"></span>
        <span>上游未结算费用：</span>
        <span class="num">{{ summaryData.unsettleCommissionPrice || 0 }}元</span>
      </div>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="dynamicColumns" :data="dataList">
        <template slot-scope="{ row }" slot="checkName">
          <div @click="lookStatement(row)" class="toDetailPage">
            {{ row.checkName }}
          </div>
        </template>
        <template slot-scope="{ row }" slot="reconciliationStatusDesc">
          <div>
            <i class="dian red" v-if="row.isOk == 2 || row.isOk == 3 || row.isOk == 6"></i>
            {{ row.reconciliationStatusDesc }}
          </div>
        </template>
        <template slot-scope="{ row }" slot="fold">
          <span>{{ row.fold?row.fold:'-' }}</span>
        </template>
        <template slot-scope="{ row }" slot="commissionType">
          <span v-if="(row.commissionType == 1||row.commissionType == 3||row.commissionType == 7||row.commissionType == 9)&&row.commissionIndex > 1">续期基础费用</span>
          <span v-else-if="row.commissionType == 1||row.commissionType == 3||row.commissionType == 7||row.commissionType == 9">基础费用</span>
          <span v-else-if="row.commissionType == 2||row.commissionType == 4||row.commissionType == 11||row.commissionType == 12||row.commissionType == 8||row.commissionType == 10" style="position: relative;">限时加费活动
            <Tooltip transfer>
              <i class="tip-icon">?</i>
              <template #content>
                <div v-if="row.activityName">
                  <div>{{ row.activityName }}</div>
                  <span>{{ '(' +  row.activityBegin+ '至'+ row.activityEnd+ ')' }}</span>
                </div>
                <div v-else>-</div>
            </template>
            </Tooltip>
          </span>
          <span v-else-if="row.commissionType == 5||row.commissionType == 21">后置费用</span>
          <span v-else-if="row.commissionType == 13||row.commissionType == 14">梯度加费</span>
          <span v-else-if="row.commissionType == 15||row.commissionType == 16">续年服务津贴</span>
          <span v-else-if="row.commissionType == 17||row.commissionType == 18">继续率费用</span>
        </template>
        <template slot-scope="{ row }" slot="orgName">
          <span>{{ row.orgName }} / {{ row.groupName }}</span>
        </template>
        <template slot-scope="{ row }" slot="salesmanName">
          <span>{{ row.salesmanName }} / {{ row.owerName }}</span>
        </template>
        <template slot-scope="{ row }" slot="holderName">
          <span>{{ row.holderName }} / {{ row.insuranceName }} </span>
        </template>
        <template slot-scope="{ row }" slot="status">
          <span>{{
            row.status == 0 ? "已终止" : row.status == 1 ? "已承保" : "已退保"
          }}</span>
        </template>
        <template slot-scope="{ row }" slot="action">
          <div v-if="row.sourceType!=1">
            <span class="table-btn" v-if="row.isDeduct == '1' && row.policyStatus =='已退保' && (row.reconciliationStatus == '0' ||  row.reconciliationStatus == '2')" @click="openCommissionDeduction(row)">修改扣款</span>
            <span class="table-btn" v-else-if="row.isDeduct == '1' && row.policyStatus =='已退保' && (row.reconciliationStatus == '1' ||  row.reconciliationStatus == '3')" style="color: grey;">修改扣款</span>
            <span class="table-btn" v-else-if="row.canDeduct == '1' && row.policyStatus =='已退保'" @click="openCommissionDeduction(row)">扣款</span>
            <span class="table-btn" v-else-if="row.canDeduct == '0' && row.policyStatus =='已退保'"  style="color: grey;">扣款</span>
          </div>
          <span v-else>-</span>
        </template>
      </Table>
      <Page
        :total="total"
        :current.sync="pageNum"
        :page-size="pageSize"
        show-total
        @on-change="getList"
        style="text-align: center; margin-top: 20px"
      />
    </div>

    <Modal
      title="结算"
      v-model="settlementShow"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="settlementFormRef"
        :model="settlementForm"
        class="page-form formGauge"
        :rules="settlementFormRules"
        :label-width="110"
        inline
      >
        <FormItem prop="settleDate" class="full" label="结算周期">
          <DatePicker
            v-model="settlementForm.settleDate"
            @on-change="changeSettleDate"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择结算周期"
            style="width: 300px"
            :transfer="true"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="settlementShow = false" ghost
          >取消</Button
        >
        <Button type="primary" @click="saveSettlement" :loading="loading"
          >确认</Button
        >
      </div>
    </Modal>

    <Modal
      title="生成结算批次"
      v-model="addVisible"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="addFormRef"
        :model="addForm"
        :rules="addFormRules"
        v-loading="settleLoading"
        class="page-form"
        :label-width="90"
        inline
      >
        <FormItem class="full" label="总单量">
          {{ addForm.num }}
        </FormItem>
        <FormItem class="full" label="总保费">
          {{ addForm.amount }}
        </FormItem>
        <FormItem class="full" label="总费用">
          {{ addForm.checkAmount }}
        </FormItem>
        <FormItem prop="checkId" class="full pc-wrap" label="批次名称">
          <Select
            v-model="addForm.checkId"
            clearable
            @on-change="selectBatch(addForm, $event)"
          >
            <Option
              :value="item.id"
              v-for="(item, i) in batchList"
              :key="i"
              :label="item.checkName"
            ></Option>
          </Select>
          <Button type="primary" ghost @click="addBatch">新增批次</Button>
        </FormItem>
        <FormItem prop="checkDate" class="full" label="结算日期">
          <DatePicker
            format="yyyy-MM-dd"
            :disabled="true"
            v-model="addForm.checkDate"
            type="date"
            placeholder="请选择"
            :transfer="true"
          ></DatePicker>
        </FormItem>
        <FormItem prop="checkUser" class="full" label="核收人">
          <Input
            type="text"
            v-model="addForm.checkUser"
            placeholder="请输入"
            :maxlength="32"
            :show-word-limit="true"
            clearable
          ></Input>
        </FormItem>
        <FormItem prop="consultRemark" class="full" label="备注">
          <Input
            type="textarea"
            :rows="4"
            v-model.trim="addForm.consultRemark"
            :maxlength="300"
            :show-word-limit="true"
            placeholder="请输入"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="addVisible = false" ghost>取消</Button>
        <Button type="primary" :loading="btnLoading" @click="saveAddform()"
          >保存</Button
        >
      </div>
    </Modal>
    <Modal
      title="新增批次"
      v-model="addbatchVisible"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="addbatchRef"
        :model="addbatchForm"
        class="page-form formGauge"
        :label-width="100"
        inline
      >
        <FormItem
          prop="supplierType"
          class="full"
          label="供应商类型"
          :rules="$units.formRule.required()"
        >
        <Select v-model="addbatchForm.supplierType" clearable @on-change="changeSupplierType">
            <Option value="1">保险公司</Option>
            <Option value="2">合作通道</Option>
          </Select>
        </FormItem>
        <FormItem
          prop="supplierId"
          class="full"
          label="供应商"
          :rules="$units.formRule.required()"
          v-if="addbatchForm.supplierType"
        >
        <Select v-model="addbatchForm.supplierId" filterable clearable>
          <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
        </Select>
        </FormItem>
        <FormItem
          prop="checkName"
          class="full"
          label="批次名称"
          :rules="$units.formRule.required()"
        >
          <Input
            type="text"
            v-model.trim="addbatchForm.checkName"
            :maxlength="64"
            :show-word-limit="true"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem
          prop="checkDate"
          class="full"
          label="结算日期"
          :rules="$units.formRule.required('请选择结算日期', 'change', 'date')"
        >
          <DatePicker
            type="date"
            v-model="addbatchForm.checkDate"
            format="yyyy-MM-dd"
            placeholder="请选择"
            :transfer="true"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="addbatchVisible = false" ghost
          >取消</Button
        >
        <Button type="primary" @click="saveBatch()">确认</Button>
      </div>
    </Modal>

    <Modal
      :title="title"
      v-model="commissionVisible"
      width="1200px"
      class-name="commissionDeduction"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="commissionRef"
        :model="commissionDeduction"
        class="page-form formGauge commissionDeduction"
        :label-width="120"
        inline
      >
        <FormItem label="保单号">
          {{ commissionDeduction.policyNo }}
        </FormItem>
        <FormItem label="保单年度">
          {{ commissionDeduction.commissionIndex }}
        </FormItem>
        <FormItem label="交费期次">
          {{ commissionDeduction.commissionPeriods }}
        </FormItem>
        <FormItem label="保单状态">
          {{ commissionDeduction.policyStatus }}
        </FormItem>
        <FormItem label="上游结算状态">
          {{ commissionDeduction.settlementStatus }}
        </FormItem>
        <FormItem label="对账状态">
          {{ commissionDeduction.reconciliationStatusDesc }}
        </FormItem>
        <FormItem label="费用">
          {{ commissionPrice }}元
          <span v-if="commissionDeduction.reviseCommissionPrice">(强平：{{ commissionDeduction.reviseCommissionPrice }}元)</span>
        </FormItem>
        <FormItem
          prop="fee"
          label="退费金额"
          v-if="![2,4,11,12,8,10].includes(commissionDeduction.commissionType)"
        >
        <InputNumber
            :min="0"
            v-model="commissionDeduction.fee"
            placeholder="请输入"
          ></InputNumber>元
        </FormItem>
        <FormItem
          prop="commissionPrice"
          :rules="$units.formRule.required('请输入本期扣除费用', 'change', 'number')"
          label="本期扣除费用"
        >
        <InputNumber
            :min="0"
            v-model="commissionDeduction.commissionPrice"
            placeholder="请输入"
          ></InputNumber>元
        </FormItem>
        <FormItem label="扣款原因" class="full" prop="deductType" :rules="$units.formRule.required('请选择扣款原因', 'change')" style="width: 100%">
          <Select v-model="commissionDeduction.deductType" placeholder="请选择" filterable clearable transfer>
            <Option value="1">退保</Option>
            <Option value="2">部分退保</Option>
            <Option value="3">退现价</Option>
            <Option value="4">其他</Option>
          </Select>
        </FormItem>
        <FormItem label="" prop="deductMsg" :rules="$units.formRule.required('请填写原因')" style="width: 100%" class="full" v-if="commissionDeduction.deductType == '2' ||commissionDeduction.deductType == '4'">
          <Input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="commissionDeduction.deductMsg" placeholder="请输入" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="commissionVisible = false" ghost
          >取消</Button
        >
        <Button type="primary" @click="saveCommissionDeduction()">确认</Button>
      </div>
    </Modal>
    <settlement ref="settlement" @getList="getList"></settlement>
  </div>
</template>

<script>
import settlement from "./settlement.vue";
import { mapState } from "vuex";
import { pageTool } from "@/api/mixins";
export default {
  mixins: [pageTool],
  components: {
    settlement,
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  data() {
    return {
      supplierList:[],
      commissionPrice:0,
      cur: 0,
      title:'扣款',
      feeType: [
        {
          name: "未核查",
          value: "0",
          key: "noExamine",
        },
        {
          name: "已核查",
          value: "1",
          key: "alreadyExamine",
        },
      ],
      pageNum: 1,
      pageSize: 10,
      summaryData: {
        counts: '',
        totalFee: '',
        totalCommissionPrice: '',
        unsettleCommissionPrice: '',
        settledCommissionPrice: '',
        settledReconciledCommissionPrice:'',
        settledUnreconciliationCommissionPrice:''
      },// 系统汇总数据
      dynamicColumns: [],
      dataList: [],
      total: 0,
      listLoading: false,
      settlementShow: false,
      settlementForm: {
        settleDate: "",
      },
      settlementFormRules: {
        settleDate: [
          {
            required: true,
            type: "date",
            message: "请选择结算日期",
            trigger: "change",
          },
        ],
      },
      rowData: null,
      loading: false,

      addForm: {
        amount: "", //总保费
        billNum: "", //发票号
        checkAmount: "", //总核收金额
        checkDate: "", //核收日期
        checkType: "", //1首年核收  2、预收
        checkUser: "", //核收人
        commissionIdList: [],
        consultRemark: "", //描述
        num: "", //数量
        type: "1", //1、多条 2、单条选择
        checkId: "", //总批次id
      },
      addFormRules: {
        checkDate: [
          {
            required: true,
            message: "请选择结算日期",
            type: "date",
            trigger: "change",
          },
        ],
        checkId: [
          {
            required: true,
            message: "请选择批次",
            trigger: "change",
          },
        ],
      },
      settleLoading: false,
      btnLoading: false,
      batchList: [], // 结算批次列表
      commissionVisible:false,
      commissionDeduction:{
        fee:0,
        commissionPrice:0,
        deductType:'',
      },
      addbatchVisible: false,
      addbatchForm: {},
      addVisible: false,
    };
  },
  props: ["columns", "brokerageType", "getlistUrl"],
  created() {
    // this.userInfo.levelCode = '10005'
    // this.userInfo.levelCode = '10004'
    // this.userInfo.userType = 1;
    // if (this.brokerageType == 1) {
    //   this.dynamicColumnsFun2();
    // } else if (this.brokerageType == 2) {
    //   this.dynamicColumnsFun2();
    // }
    this.dynamicColumnsFun2();
    this.getList();
    // this.showAction();
  },
  watch: {
    settlementShow(v) {
      this.settlementForm.settleDate = "";
      this.$refs["settlementFormRef"].resetFields();
    },
  },
  methods: {
    //获取汇总数据
    getSummaryData() {
      let params = Object.assign({}, this.$parent.$parent.$parent.searchParams);
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      params.tab = this.brokerageType;
      params.isFirst = 1;
      //对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
      params.reconciliationType = 1;
      if (this.brokerageType == 2) {
        delete params.applyOrgId;
      }
      if (this.brokerageType == 3) {
        params.receivableStatus = params.payStatus;
        delete params.payStatus;
      }
      this.$http({
        url: '/buz/commissionReconciliation/statistics',
        type: 'POST',
        data: params,
      }).then((res) => {
        if (res.data) {
          this.summaryData = res.data
        }
      })
    },
    openCommissionDeduction(row){
      this.commissionDeduction = JSON.parse(JSON.stringify(row))
      this.commissionDeduction.deductType = String(this.commissionDeduction.deductType) 
      if(this.commissionDeduction.isDeduct =='1'){
        this.commissionDeduction.commissionPrice = -this.commissionDeduction.commissionPrice
        this.commissionDeduction.fee = -this.commissionDeduction.fee
        this.getDetail(row.deductLogId, row);
      }else{
        this.commissionPrice = this.commissionDeduction.commissionPrice
      }
      this.commissionDeduction.fee = Number(this.commissionDeduction.fee)
      this.commissionDeduction.commissionPrice = Number(this.commissionDeduction.commissionPrice)

      this.commissionVisible = true
      this.$refs.commissionRef.fields.forEach(item=>{
        item.validateState = '';
        item.validateMessage = '';
      });
      
    },
    getDetail(id, item) {
      this.$http({
        url: '/buz/commissionLog/read/detail',
        type: 'GET',
        data: {
          id
        }
      }).then(res => {
        this.commissionPrice = res.data.commissionPrice;
        this.commissionDeduction.fee = Math.abs(item.fee);
        this.commissionDeduction.commissionPrice = Math.abs(item.commissionPrice);
        this.commissionDeduction.deductType = item.deductType;
        this.commissionDeduction.deductMsg = item.deductMsg;
        this.commissionDeduction.id = item.id;
      });
    },
    saveCommissionDeduction(){
      this.$refs.commissionRef.validate(valid => {
        if (valid) {
          debugger
          let formData = {},url=''
          this.commissionDeduction = JSON.parse(JSON.stringify(this.commissionDeduction));
          // 保费及费用传参为负数
          formData.commissionPrice = -this.commissionDeduction.commissionPrice
          formData.fee = -this.commissionDeduction.fee
          formData.deductType = this.commissionDeduction.deductType
          if(formData.deductType == '2' ||  formData.deductType == '4'){
            formData.deductMsg = this.commissionDeduction.deductMsg
          }else{
            delete formData.deductMsg
          }
          // 限时加费去掉保费
          if([2,4,11,12,8,10].includes(this.commissionDeduction.commissionType*1)) {
            delete formData.fee;
          }
          if(this.commissionDeduction.isDeduct =='1'){
            url = '/buz/commissionLog/changeDeduct'
            formData.id = this.commissionDeduction.id
          }else{
            url = '/buz/commissionLog/deductCommission'
            formData.commissionLogId = this.commissionDeduction.id
          }
          this.$http({
            url,
            type: 'POST',
            data: formData
          }).then((res) => {
            this.commissionVisible = false
            this.getList()
          })
        }
      });
    },
    lookStatement(row){
      this.$router.push({
        name: "statementDetail",
        query: { id: row.checkId,step:row.step },
      });
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.addbatchForm.supplierId;
      this.supplierList = [];
      if(value==1){
        var url = '/buz/insuranceCompany/read/all'
      }else if(value==2) {
        var url = '/buz/insuranceChannel/read/list'
      }else if (!value) {
        this.supplierList = [];
      }
      if(value){
        this.$http({
          url,
          type: 'POST',
          data:{}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      console.log(this.supplierList);
    },
    // showAction() {
    //   if(!this.$units.pointAction('offline_9_3')){
    //     this.dynamicColumns.splice(this.dynamicColumns.length-1, 1);
    //   }
    // },
    getList() {
      let params = Object.assign({}, this.$parent.$parent.$parent.searchParams);
      params.pageNo = this.pageNum;
      params.pageSize = this.pageSize;
      params.tab = this.brokerageType;
      // params.checkStatus = this.cur + "";
      params.isFirst = 1;
      //对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
      params.reconciliationType = 1;
      if (this.brokerageType == 2) {
        delete params.applyOrgId;
      }
      if (this.brokerageType == 3) {
        params.receivableStatus = params.payStatus;
        delete params.payStatus;
      }
      this.listLoading = true;
      this.$http({
        type: "POST",
        url: this.getlistUrl,
        data: params,
      })
        .then((res) => {
          this.listLoading = false;
          this.dataList = res.data;
          this.total = res.total;
          this.getSummaryData()
        })
        .catch((err) => {
          this.listLoading = false;
        });
    },
    toggleList(item) {
      this.cur = item.value;
      this.dynamicColumnsFun2();
      this.pageNum = 1;
      this.getList();

      this.$emit("changeTabsBtn", item.value);
    },
    dynamicColumnsFun1() {
      this.dynamicColumns = [];
    },
    dynamicColumnsFun2() {
      this.dynamicColumns = [];
      if (this.userInfo.userType == 4) {
        this.columns.forEach((el, i) => {
          if (el.title == "操作") {
            this.columns.splice(i, 1);
          }
        });
      }
      if (this.cur == 1 && this.userInfo.userType != 4) {
        this.columns.forEach((item) => {
          if (item.title != "操作") {
            this.dynamicColumns.push(item);
          }
        });
      } else {
        this.columns.forEach((item) => {
          if (this.cur == 1) {
            if (item.title == "回款状态") {
              item.cur = false;
            }
          } else {
            if (item.title == "回款状态") {
              item.cur = true;
            }
          }
          if (!item.cur) {
            this.dynamicColumns.push(item);
          }
        });
      }
    },
    generate() {
      this.settlementShow = true;
    },
    sexamine(row) {
      if (this.brokerageType == 1 || this.brokerageType == 3) {
        this.$refs.settlement.settlementForm.commissionIdList = [row.id];
        this.$refs.settlement.settlementVisible = true;
        this.$refs.settlement.getCheckNo(this.brokerageType);
      } else if (this.brokerageType == 2) {
        this.settlementShow = true;
        this.rowData = row;
      }

    },
    saveSettlement() {
      this.$refs["settlementFormRef"].validate((valid) => {
        if (valid) {
          let params = Object.assign(
            {},
            this.$parent.$parent.$parent.searchParams
          );
          params.settleDate = this.settleDate;
          params.checkStatus = this.cur;
          if (this.rowData) {
            params.id = this.rowData.id;
          }
          this.loading = true;
          this.$http({
            url: "/buz/commissionLog/baseCommissionSettlement",
            type: "POST",
            data: params,
            apiPermissionCode:'offline_9_4'
          })
            .then((res) => {
              this.getList();
              this.loading = false;
              this.$Message.success("操作成功");
              this.rowData = null;
              this.settlementShow = false;
            })
            .catch((err) => {
              this.loading = false;
            });
        }
      });
    },
    changeSettleDate(date) {
      this.settleDate = date;
    },
    generateSettle() {
      this.$nextTick(() => {
        this.$refs["addFormRef"] && this.$refs["addFormRef"].resetFields();
      });
      // 核收模型
      this.getSettleDetail();
      // 所有批次
      this.getCheckNo();
    },
    // 选择批次
    selectBatch(formData, id) {
      const data = this.batchList.find((item) => {
        return item.id == id;
      });
      this.$set(formData, "checkDate", data.checkDate);
    },
    // 获取所有批次
    getCheckNo() {
      this.$http({
        url: "/buz/molCommissionCheck/read/allCheckNo",
        type: "POST",
        data: {
          source: this.brokerageType == 1 ? "1" : "2",
        },
      }).then((res) => {
        this.batchList = res.data;
      });
    },
    getSettleDetail() {
      this.settleLoading = true;
      const params = JSON.parse(
        JSON.stringify(this.$parent.$parent.$parent.searchParams)
      );
      params.checkStatus = this.cur;
      params.tab = this.brokerageType;
      params.isFirst = 1;

      this.$http({
        url: "/buz/commissionLog/getCheckModel",
        type: "post",
        data: params,
      })
        .then((res) => {
          this.settleLoading = false;
          if (res.httpCode == 1) {
            this.addForm = res.data;
            this.addForm.checkDate = "";
            this.addVisible = true;
          }
        })
        .catch((e) => {
          this.settleLoading = false;
        });
    },
    // 新增批次
    addBatch() {
      this.addbatchVisible = true;
      this.addbatchForm = {};
    },
    // 生成结算批次
    saveAddform() {
      this.settleLoading = true;
      this.$units.notCloseModal(this);
      this.addForm.type = "1";
      this.$refs["addFormRef"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/commissionLog/batchAcceptCommission",
            type: "POST",
            data: this.addForm,
          }).then((res) => {
            this.settleLoading = false;
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
              if (this.brokerageType == 3) {
                setTimeout(() => {
                  this.$router.push({
                    path: "/offline/settlement/subordinateBatch",
                    query: {},
                  });
                }, 800);
              }
            }
            this.addVisible = false;
          });
        } else {
          this.settleLoading = false;
        }
      });
    },
    // 新增批次
    saveBatch() {
      this.$units.notCloseModal(this);
      this.$refs["addbatchRef"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/molCommissionCheck/add",
            type: "POST",
            data: {
              checkName: this.addbatchForm.checkName,
              supplierType:this.addbatchForm.supplierType,
              supplierId:this.addbatchForm.supplierId,
              commissionIndex:1,
              checkDate: this.$units.formatDate(
                this.addbatchForm.checkDate,
                "yyyy-MM-dd"
              ),
              source: this.brokerageType == 1 ? "1" : "2",
            },
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("新增成功");
              this.getCheckNo();
            }
            this.addbatchVisible = false;
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .ivu-select-dropdown{
  max-height: 120px;
}
.statistics-container {
  display: flex;
  margin: 10px 0;
  .statistics-item {
    display: flex;
    margin-right: 20px;

    .dot {
      width: 4px;
      height: 4px;
      background: #236DFF;
      align-self: center;
      margin-right: 7px;
    }
    .num{
      color: #3C464F;
    }
  }
}
.commissionDeduction{
  /deep/ .ivu-form-item{
    width: 30%;
  }
  /deep/ .ivu-form-item-content{
    display: flex;
  }
}

.toDetailPage{
  color: #236DFF;
  cursor: pointer;
}
.ivu-btn{
  min-width:72px
}
.box {
  // margin-top: 20px;
}
.btns {
  width: 100%;
  height: 10px;
  position: relative;
  .tools-box {
    display: inline-block;
    margin-left: auto;
    position: absolute;
    right: 0;
    top: -50px;
  }
}
.dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #E3461F;
    }
  }
.btn {
  float: left;
  &:hover {
    cursor: pointer;
  }
  font-size: 12px;
  color: #236dff;
  float: left;
  padding: 0 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #F7F8FA;
  color: #727c8e;
  margin-right: 10px;
  border-radius: 5px;

  &.active {
    background: #236dff;
    color: #fff;
  }
}
</style>